import { EarningType } from "./enums";

export * from "./deliveriesLabels";

export * from "./enums";
export * from "./expenses";
export * from "./transaction";

export const EARNING_TYPE_LABELS: Record<EarningType, string> = {
  [EarningType.ProductsReselling]: "Own sales",
  [EarningType.ProductsResellingByReferral]: "Referral"
};

export const EARNING_TYPE_FILTER_SEARCH_PARAMETER = "type";
export const EARNING_RESELLER_FILTER_SEARCH_PARAMETER = "resellerId";
export const EARNING_SEARCH_SEARCH_PARAMETER = "search";
